"use strict";
exports.__esModule = true;
var Types_1 = require("../Types");
var EventProperties_1 = require("../EventProperties");
var ProviderBase_1 = require("./ProviderBase");
var SchemaBuilder_1 = require("./SchemaBuilder");
var _base;
var _optionalDataConsentCallback;
var _optionalDataConsentState;
var _optionalDataEventCount = 0;
function HasOptionalConsent(commonProperties) {
    var _a;
    if (_optionalDataConsentCallback === undefined) {
        return true;
    }
    var consentValue = _optionalDataConsentCallback();
    if (consentValue != _optionalDataConsentState) {
        (_a = _base) === null || _a === void 0 ? void 0 : _a.Write(SchemaBuilder_1.SchemaBuilder.ForRequiredCritical(commonProperties, {
            eventName: "OptionalDataConsentChanged"
        }, {
            activeConsentState: consentValue,
            priorConsentState: _optionalDataConsentState,
            optionalEventCount: _optionalDataEventCount
        }));
        _optionalDataConsentState = consentValue;
        _optionalDataEventCount = 1;
    }
    else {
        _optionalDataEventCount++;
    }
    return consentValue;
}
var ComponentProvider = (function () {
    function ComponentProvider() {
    }
    ComponentProvider.prototype.Write = function (commonProperties, eventProperties, data) {
        var _a;
        (_a = _base) === null || _a === void 0 ? void 0 : _a.Write(SchemaBuilder_1.SchemaBuilder.ForComponent(commonProperties, eventProperties, data, eventProperties.groupIdType !== Types_1.GtlGroupIdType.OptionalDiagnostic ||
            HasOptionalConsent(commonProperties)));
        if (EventProperties_1.ClickstreamEventProperties.IncrementCallback && eventProperties.DIV) {
            EventProperties_1.ClickstreamEventProperties.IncrementCallback(eventProperties.DIV, eventProperties.eventName);
        }
    };
    ComponentProvider.prototype.WriteWithPartB = function (commonProperties, eventProperties, data, baseType, baseData) {
        var _a;
        (_a = _base) === null || _a === void 0 ? void 0 : _a.Write(SchemaBuilder_1.SchemaBuilder.ForComponentWithBase(commonProperties, eventProperties, data, baseType, baseData, eventProperties.groupIdType !== Types_1.GtlGroupIdType.OptionalDiagnostic ||
            HasOptionalConsent(commonProperties)));
        if (EventProperties_1.ClickstreamEventProperties.IncrementCallback && eventProperties.DIV) {
            EventProperties_1.ClickstreamEventProperties.IncrementCallback(eventProperties.DIV, eventProperties.eventName);
        }
    };
    return ComponentProvider;
}());
var CriticalProvider = (function () {
    function CriticalProvider() {
    }
    CriticalProvider.prototype.WriteOptional = function (commonProperties, eventProperties, data) {
        var _a;
        (_a = _base) === null || _a === void 0 ? void 0 : _a.Write(SchemaBuilder_1.SchemaBuilder.ForOptionalCritical(commonProperties, eventProperties, data, HasOptionalConsent(commonProperties)));
    };
    CriticalProvider.prototype.WriteRequired = function (commonProperties, eventProperties, data) {
        var _a;
        (_a = _base) === null || _a === void 0 ? void 0 : _a.Write(SchemaBuilder_1.SchemaBuilder.ForRequiredCritical(commonProperties, eventProperties, data));
    };
    return CriticalProvider;
}());
var BothProviders = (function () {
    function BothProviders() {
    }
    BothProviders.prototype.AsCriticalOptional = function (commonProperties, eventProperties, criticalEventProperties, data) {
        var _a, _b, _c;
        var hasOptionalConsent;
        if (eventProperties.groupIdType !== Types_1.GtlGroupIdType.OptionalDiagnostic) {
            (_a = _base) === null || _a === void 0 ? void 0 : _a.Write(SchemaBuilder_1.SchemaBuilder.ForComponent(commonProperties, eventProperties, data, true));
            hasOptionalConsent = HasOptionalConsent(commonProperties);
        }
        else {
            hasOptionalConsent = HasOptionalConsent(commonProperties);
            _optionalDataEventCount++;
            (_b = _base) === null || _b === void 0 ? void 0 : _b.Write(SchemaBuilder_1.SchemaBuilder.ForComponent(commonProperties, eventProperties, data, hasOptionalConsent));
        }
        (_c = _base) === null || _c === void 0 ? void 0 : _c.Write(SchemaBuilder_1.SchemaBuilder.ForOptionalCritical(commonProperties, criticalEventProperties, data, hasOptionalConsent));
        if (EventProperties_1.ClickstreamEventProperties.IncrementCallback && eventProperties.DIV) {
            EventProperties_1.ClickstreamEventProperties.IncrementCallback(eventProperties.DIV, eventProperties.eventName);
        }
    };
    BothProviders.prototype.AsCriticalRequired = function (commonProperties, eventProperties, criticalEventProperties, data) {
        var _a, _b;
        (_a = _base) === null || _a === void 0 ? void 0 : _a.Write(SchemaBuilder_1.SchemaBuilder.ForComponent(commonProperties, eventProperties, data, eventProperties.groupIdType !== Types_1.GtlGroupIdType.OptionalDiagnostic ||
            HasOptionalConsent(commonProperties)));
        (_b = _base) === null || _b === void 0 ? void 0 : _b.Write(SchemaBuilder_1.SchemaBuilder.ForRequiredCritical(commonProperties, criticalEventProperties, data));
        if (EventProperties_1.ClickstreamEventProperties.IncrementCallback && eventProperties.DIV) {
            EventProperties_1.ClickstreamEventProperties.IncrementCallback(eventProperties.DIV, eventProperties.eventName);
        }
    };
    return BothProviders;
}());
var TelemetryProviders = (function () {
    function TelemetryProviders(logger, registrationOptions, optionalDataConsentCallback) {
        var _a, _b, _c, _d;
        this.Component = new ComponentProvider();
        this.Critical = new CriticalProvider();
        this.DoublePump = new BothProviders();
        _optionalDataConsentCallback = optionalDataConsentCallback;
        _optionalDataConsentState = undefined;
        _optionalDataEventCount = 0;
        _base = new ProviderBase_1.ProviderBase(logger, EventProperties_1.ComponentEventProperties.ComponentName, optionalDataConsentCallback !== undefined, (_a = registrationOptions) === null || _a === void 0 ? void 0 : _a.InstrumentationKeyOverride, (_b = registrationOptions) === null || _b === void 0 ? void 0 : _b.ProviderGuidOverride, (_c = registrationOptions) === null || _c === void 0 ? void 0 : _c.ProviderGroupGuidOverride, (_d = registrationOptions) === null || _d === void 0 ? void 0 : _d.gpcDataSharingOptIn);
    }
    TelemetryProviders.prototype.Unregister = function () {
        var _a;
        (_a = _base) === null || _a === void 0 ? void 0 : _a.Unregister();
        _base = undefined;
    };
    return TelemetryProviders;
}());
exports.TelemetryProviders = TelemetryProviders;
//# sourceMappingURL=TelemetryProviders.js.map